module.exports = __webpack_public_path__ + "img/ldgh.2cd5ee9a.png";